import React from "react";
type ScarcityBarProps = {
  spotsLeft?: number;
  total?: number;
};
export function ScarcityBar({
  spotsLeft = 7,
  total = 100
}: ScarcityBarProps) {
  const filled = Math.round((total - spotsLeft) / total * 100);
  return <div className="w-full rounded-2xl border-2 border-danger/25 bg-dangerSoft p-4" data-id="element-52" data-mp="2l4elu8i2z4mi">
      <div className="flex items-center justify-between gap-3" data-id="element-53" data-mp="2q2zcphbg0bya">
        <p className="flex items-center gap-2 text-sm font-bold text-ink sm:text-base" data-id="element-54" data-mp="2b705sa02khuq">
          <span className="live-dot h-2.5 w-2.5 shrink-0 rounded-full bg-danger" aria-hidden="true" data-id="element-55" data-mp="2g5tja2fcw8uw" />
          Only <span className="text-danger" data-id="element-56" data-mp="226bq7av129fq">{spotsLeft} spots</span> left at the promo price
        </p>
        <span className="shrink-0 font-display text-lg font-black text-danger" data-id="element-57" data-mp="274vehhx3fxb9">{filled}%</span>
      </div>
      <div className="mt-3 h-4 w-full overflow-hidden rounded-full bg-white ring-1 ring-danger/20" role="progressbar" aria-valuenow={filled} aria-valuemin={0} aria-valuemax={100} aria-label="Promotional spots claimed" data-id="element-58" data-mp="eyqd07x2rqj">
        <div className="h-full rounded-full bg-danger" style={{
        width: `${filled}%`
      }} data-id="element-59" data-mp="33kihzmqi60j6" />
      </div>
      <p className="mt-2 text-xs font-medium text-muted" data-id="element-60" data-mp="2zjgpdor3cmq6">
        When the spots run out, the price returns to its regular value.
      </p>
    </div>;
}